import useCurrentProviderInfo from "./useCurrentProviderInfo";

export const useIsEligibleToRequestScripts = (): boolean => {
  const { data } = useCurrentProviderInfo();

  // check if provider is ellgible for create script requests - think of this as a userMedspa level feature flag
  return !!data?.userMedspa[0]?.isEligibleForScripts;
};
